import React from 'react';
import { Mail } from 'lucide-react';

const SUPPORT_EMAIL = 'support@primeface.io';

/**
 * Shared footer badge. `variant="layout"` renders the desktop-only bordered bar
 * used inside the app shell; `variant="auth"` renders the compact centred one.
 */
export const BrandFooter = ({ variant = 'auth' }) => {
  if (variant === 'layout') {
    return (
      <div className="hidden md:flex items-center justify-center gap-3 py-4 border-t border-[var(--lux-border)]">
        <span className="text-xs text-[var(--lux-text-muted)]">PrimeFace © 2026 OpenMeta</span>
        <span className="text-xs text-lux-text/15">•</span>
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          data-testid="footer-support-email"
          className="flex items-center gap-1 text-xs text-[var(--lux-text-muted)] hover:text-[var(--lux-gold)] transition-colors duration-200"
        >
          <Mail className="w-3 h-3" />
          {SUPPORT_EMAIL}
        </a>
      </div>
    );
  }
  return (
    <div className="text-center py-3 flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-3">
      <span className="text-xs text-[var(--lux-text-muted)]">PrimeFace © 2026 OpenMeta</span>
      <span className="hidden sm:inline text-xs text-lux-text/15">•</span>
      <a
        href={`mailto:${SUPPORT_EMAIL}`}
        data-testid="auth-footer-support-email"
        className="text-xs text-[var(--lux-text-muted)] hover:text-[var(--lux-gold)] transition-colors duration-200"
      >
        {SUPPORT_EMAIL}
      </a>
    </div>
  );
};
